// App.js - Update imports and wrap with LanguageProvider
import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { LanguageProvider } from './contexts/LanguageContext'  // Add this
import MainLayout from './components/MainLayout'
import SingleViewer from './components/SingleViewer'
import ListViewer from './components/ListViewer'
import SettingsPage from './components/SettingsPage'  // Add this

function MutableApp(){
    return ( <>
        <div className="App">
            <Routes>
                <Route path="/" element={<MainLayout></MainLayout>}>
                    <Route index={true} element={<SingleViewer use_id={"props"} entity="pages" ob_id="index"></SingleViewer>}></Route>
                    <Route path="pages" element={<ListViewer entity="pages"></ListViewer>}></Route>
                    <Route path="page/:ob_id" element={<SingleViewer entity="pages"></SingleViewer>}></Route>
                    <Route path="projects" element={<ListViewer entity="projects"></ListViewer>}></Route>
                    <Route path="project/:ob_id" element={<SingleViewer entity="projects"></SingleViewer>}></Route>
                    <Route path="settings" element={<SettingsPage></SettingsPage>}></Route>  {/* Add this */}
                </Route>
                <Route path="*" element={<SingleViewer entity="pages" ob_id="page404"></SingleViewer>}></Route>
            </Routes>
        </div>
    </> )
}

function App() {
    return ( 
        <BrowserRouter>
            <LanguageProvider>  {/* Wrap with LanguageProvider */}
                <MutableApp></MutableApp>
            </LanguageProvider>
        </BrowserRouter> 
    )
}

export default App